import React from 'react'
import './card-gallery.scss'


const CardGallery = ({ info, slide = false }) => {
  return (
    <div className={`f-card-gallery ${slide ? 'slide' : 'grid'}`}>
      <div className='f-card-gallery__img'>
        <img src={info.img} alt='galeri img' />
      </div>
      <div className='f-card-gallery__description'>
        <h4 className='f-card-gallery__title'>{info.title}</h4>
        <p className='f-card-gallery__author'>{info.author}</p>
      </div>
    </div>
  )
}

export default CardGallery
